import { ProtocolSettings } from "./ProtocolSettings";
import { ProtocolSettingsTypes } from "./ProtocolSettingsTypes";
import { ObjUtils } from "../Utils/ObjUtils";
	
export class VimSettings extends ProtocolSettings {

	public UserName: string;
	public Password: string;

	constructor() {
		super();

		this.UserName = "";
		this.Password = "";
	}

	public get HasUserName(): boolean {
		return !!this.UserName;
	}

	public get HasPassword(): boolean {
		return !!this.Password;
	}

	public get SettingsType(): string {
		return ProtocolSettingsTypes.Vim;
	}

	public get Summary(): string {
		return `Username: ${this.UserName}`;
	}

	public Copy(obj: ProtocolSettings): void {
		if (!(obj instanceof VimSettings))
			return;
		let other = (obj as VimSettings);

		super.Copy(obj);

		this.UserName = "";
		if (other.HasUserName)
			this.UserName = other.UserName;

		this.Password = "";
		if (other.HasPassword)
			this.Password = other.Password;
	}

	public Clone(): ProtocolSettings {
		let clone = new VimSettings();
		clone.Copy(this);
		return clone;
	}

	public Equals(obj: any): boolean {
		if (!super.Equals(obj))
			return false;

		if (!(obj instanceof VimSettings))
			return false;
		let other: VimSettings = (obj as VimSettings);

		return (ObjUtils.Equals(this.UserName, other.UserName) &&
			ObjUtils.Equals(this.Password, other.Password));
	}

	public Write(obj: any, context: any): void {
		obj.vim = {};
		obj = obj.vim;

		super.Write(obj, context);

		if (this.HasUserName)
			obj.user_name = this.UserName;

		if (this.HasPassword)
			obj.password = this.Password;
	}

	public Read(obj: any, context: any): void {
		if (!obj.vim)
			throw new Error();
		obj = obj.vim;

		super.Read(obj, context);

		if (obj.user_name !== undefined)
			this.UserName = obj.user_name;

		if (obj.password !== undefined)
			this.Password = obj.password;
	}

}

